/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import UserRoutes from './user.routes';
import ActivationLinkDialogController from './activation-link.controller';
import AddUserController from './add-user.controller';
import UserDirective from './user.directive';
import UserTableConfig from './user-table.config';

export default angular.module('tektelic.user', [])
    .config(UserRoutes)
    .controller('ActivationLinkDialogController', ActivationLinkDialogController)
    .controller('AddUserController', AddUserController)
    .directive('tkUser', UserDirective)
    .factory('userTableConfig', UserTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/user/index.js